import { useDispatch, useSelector } from "react-redux";
import { updateOfferCount } from "../../../redux/slice/offersSlice";
import { CiCircleMinus, CiCirclePlus } from "react-icons/ci";
import "../styles.scss";

function ItemCard({ offer }: any) {
  const dispatch = useDispatch();
  const selectedOffers = useSelector(
    (state: any) => state.offers.selectedOffers
  );

  // Find the count for this offer in redux
  const count = selectedOffers.find((o: any) => o.id === offer.id)?.count || 0;

  const handleIncrement = () => {
    dispatch(updateOfferCount({ offer, type: "add" }));
  };
  const handleDecrement = () => {
    if (count > 0) dispatch(updateOfferCount({ offer, type: "remove" }));
  };

  return (
    <div className="itemCardHead">
      <img className="cardImage" src={offer.image} alt={offer.title} />
      <div className="cardContent">
        <div className="nameTxt">{offer?.title}</div>
        <div style={{ borderBottom: "1px solid white" }}></div>
        <div className="pricingHead">
          <div>
            <div className="pricingTxt">Rs. {offer.price}</div>
          </div>
          <div className="countBtnHead">
            <CiCircleMinus size={30} color="white" onClick={handleDecrement} />
            <div className="count">{count}</div>
            <CiCirclePlus size={30} color="white" onClick={handleIncrement} />
          </div>
        </div>
        <div className="pricingTxt mt-2">
          Total: Rs. {Number(offer.price) * count}
        </div>
      </div>
    </div>
  );
}

export default ItemCard;
